import { axiosClient } from '@/lib/axios';
import { MutationFunction, useMutation } from '@tanstack/react-query';
import { queryClient } from '@/lib/react-query';
import { AxiosError } from 'axios';
import { App } from 'antd';

type VotePayload = {
  body: {
    vote: string;
  };
  token?: string;
  companyID?: number;
  voteID: number;
  meetingID: number;
};

export const sendVote = async ({
  voteID,
  companyID,
  meetingID,
  body,
  token,
}: VotePayload): Promise<{ data: string }> => {
  if (token) {
    const { data } = await axiosClient.post<{ data: string }>(
      `/companies/meetings/${meetingID}/meeting-points/${voteID}/public-vote?token=${token}`,
      body,
    );
    return data;
  } else {
    const { data } = await axiosClient.post<{ data: string }>(
      `/companies/${companyID}/meetings/${meetingID}/meeting-points/${voteID}`,
      body,
    );
    return data;
  }
};
type UseSendVoteOptions = {
  config?: MutationFunction<typeof sendVote>;
  postSuccess?: () => void;
  handleAfterFailure: () => void;
};

export const useSendVote = ({ config, postSuccess, handleAfterFailure }: UseSendVoteOptions) => {
  const { notification: toaster } = App.useApp();

  return useMutation({
    onError: (error: AxiosError<{ message?: string }>) => {
      const message =
        error.response && error.response.data && typeof error.response.data.message === 'string'
          ? error.response.data.message
          : 'An unexpected error occurred';
      toaster.error({
        message: 'Something Went Wrong',
        description: message,
      });
      handleAfterFailure();
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ['vote', 'questions'],
      });
      toaster.success({
        message: 'Added Successfully',
        description: `Vote Submitted Successfully`,
      });
      postSuccess?.();
    },
    ...config,
    mutationFn: sendVote,
  });
};
